import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { Modal } from 'bootstrap';
import TapSelect from '../../../components/ui/TapSelect';
import { useSelector } from 'react-redux';
import HttpAPICall from '../../../services/HttpAPICall';
import Loader from '../../../components/ui/Loader/Loader';
import { BACKOFFICE_BASE_URL } from '../../../services/TapApiUrls';


const ModelSearchModal = forwardRef(({ onSearch, initialSearchForm }, ref) => {
    const modelFormDataUrl               =       BACKOFFICE_BASE_URL + '/model/form_data'
    const modalElem = useRef(null);
    const modal = useRef(null);
    const [form_loading, setForm_loading] = useState(false);
    const access_token = useSelector(state => state.auth.access_token);

    const initSearchForm         =          {
        search_name                         :   '',
        search_manufacturers                :   [],
    };

    const searchFormLabel        =          {
        search_name                         :   'Name : ',
        search_manufacturers                :   'Manufacturers : ',
    };

    const [manufacturers, setManufacturers] = useState([]);
    const [modelSearchForm, setModelSearchForm] = useState({ ...initSearchForm, ...initialSearchForm });
    const resetForm = () => {
        setModelSearchForm({ ...initSearchForm });
    };

    useImperativeHandle(ref, () => ({
        initModalHandler: () => {
            modalOpen();
        },
        resetForm: resetForm
    }));

  
    const modalOpen = () => {
        if (modal.current) { modal.current.show(); }
    };

    const modalClose             =       ()     => {
        if (modal.current) { modal.current.hide(); }
    };
    const getSearchFormData     =        ()     =>  {
        setForm_loading(true);
        HttpAPICall.withAthorization('GET', modelFormDataUrl, access_token, {}, {}, (resp) => {
            let respData = resp.data.manufacturers;
            setManufacturers(respData.map(m => ({ value: m.id, label: m.manufacturer })));
        }).then(() => setForm_loading(false));
    };


    useEffect(() => {
        getSearchFormData()
        modalElem.current = document.getElementById('searchModal');
        modal.current = new Modal(modalElem.current, { keyboard: false, backdrop: false });
        return () => {
            if (modal.current) {
                modal.current.dispose();
            }
        };
    }, []);


    const tapSelectChange = (selectedOption, form, formKey) => {
        if (form && formKey) {
            const newStateData = Array.isArray(selectedOption)
                ? { ...modelSearchForm, [formKey]: selectedOption.length > 0 ? selectedOption.map(o => o.value) : [] }
                : { ...modelSearchForm, [formKey]: selectedOption ? selectedOption.value : '' };

            setModelSearchForm(newStateData);
        }
    };

    const submitSearchForm = (e) => {
        e && e.preventDefault();
        let serachFormKeys = Object.keys(modelSearchForm);
        let searchedElems = [];
        let searchParams = {};
        serachFormKeys.map((key) => {
            let label = searchFormLabel[key];
            let value = modelSearchForm[key];

            if (value && value.toString().length > 0) {
                searchParams[key] = value;
                if (label) {
                    let show_val = value;
                    if (key === 'search_manufacturers') {
                        show_val = manufacturers.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    searchedElems.push(label + `<b>${show_val}</b>`);
                }
            }
        });
        onSearch(searchParams, searchedElems);
        modalClose();
    };

    const searchModalJsx = () => {
        return (
            <div className="modal fade" id="searchModal" tabIndex="-1" ref={modalElem}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="searchAssetModalLabel">Model Search</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <form id="modelSearchForm" onSubmit={submitSearchForm}>
                            <div className="modal-body">
                                {form_loading
                                    ?
                                    <Loader />
                                    :
                                    <>
                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm">Name</label>
                                            <div className="col-sm-10">
                                                <input
                                                    name="search_name"
                                                    type="text"
                                                    value={modelSearchForm.search_name}
                                                    className="form-control"
                                                    autoComplete="off"
                                                    onChange={(e) => setModelSearchForm(pre => ({ ...pre, search_name: e.target.value }))}
                                                    placeholder="Please enter Model Name"
                                                    style={{ height: "30px", fontSize: "93%" }}
                                                />
                                            </div>
                                        </div>
                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm">Manufacturer</label>
                                            <div className="col-sm-10">
                                                <TapSelect
                                                    options={manufacturers}
                                                    changeEvent={(selectedOption) => tapSelectChange(selectedOption, 'modelSearchForm', 'search_manufacturers')}
                                                    value={manufacturers.filter(u => modelSearchForm.search_manufacturers.includes(u.value))}
                                                    isSearchable={true}
                                                    isMulti={true}
                                                    isClearable={true}
                                                    placeholder="Select Manufacturer"
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                />
                                            </div>
                                        </div>
                                    </>}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="submit" className="btn btn-primary">Search</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            {searchModalJsx()}
        </>
    );
});

export default ModelSearchModal;
